module.exports = __webpack_public_path__ + "static/img/steps_mb.cd4a325.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pages/login/steps_mb.svg
// module id = edzs
// module chunks = 30